import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
      isActive
        ? "bg-primary-100 text-primary-800"
        : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label={`${siteInfo.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-700 tracking-tight text-foreground-950">
              {siteInfo.name}
            </span>
            <span className="hidden text-[10px] tracking-[0.2em] text-foreground-500 sm:block">
              SAKURA ANIME CLUB
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/works"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-500 text-background-50 transition-colors hover:bg-secondary-600 md:inline-flex"
          >
            <i className="ri-search-line" aria-hidden="true"></i>
            搜作品
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="移动端导航"
          className="border-t border-background-200 bg-background-50 lg:hidden"
        >
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-4 py-2.5 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}